// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideRefreshCw as RawLucideRefreshCw } from "lucide-react";
export const LucideRefreshCw = /* @__PURE__ */ createIcon(RawLucideRefreshCw, "LucideRefreshCw", 2);
